import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { Mutations } from '@shared/api';
import { useCardPaginationActions } from '@shared/api/providers/cardPagination';
import { API } from '@shared/types/api';

export function useRemoveCard(): (
  cardId: string,
  scope: API.EntityRecurrenceScope,
) => Promise<any> {
  const pagination = useCardPaginationActions();
  const [removeCard] = useMutation<API.RemoveCardMutation, API.RemoveCardMutationVariables>(
    Mutations.cards.remove,
  );

  return useCallback(
    async (cardId: string, scope: API.EntityRecurrenceScope) => {
      await removeCard({ variables: { input: { scope, id: cardId } } });
      pagination.removeCard(cardId);
    },
    [removeCard, pagination],
  );
}
